<template>
  <v-dialog
      v-model="isOpen"
      :style="dialogStyle"
      fullscreen
  >
    <v-card v-if="currentComponent">
      <component :is="currentComponent" v-bind="dialogProps" />
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed, watch } from "vue";
import { useRouter } from "vue-router";
import { useDialogStore } from "@/stores/dialog";

const router = useRouter();
const store = useDialogStore();

const currentComponent = computed(() => store.currentDialog?.component || null);
const dialogProps = computed(() => {
  let props = { ...store.currentDialog?.props };
  props.closeDialog = closeDialog;
  return props;
});

const dialogStyle = computed(() => {
  const width = store.currentDialog?.props?.width;

  if (width) {
    const widthValue = typeof width === 'number' ? `${width}px` : width;
    return {
      'width': widthValue,
      'margin-left': `calc(100% - ${widthValue})`
    };
  }

  return {
    'width': '40%',
    'margin-left': '60%'
  };
});

const closeDialog = () => store.closeDialog();
const isOpen = computed({
  get: () => !!store.currentDialog,
  set: (value) => { if (!value) closeDialog(); }
});

watch(() => router.currentRoute.value, closeDialog);
</script>

<style scoped lang="scss">
.v-dialog {
  box-shadow: -20px 20px 18px 0px #0404042e;
}

:deep(.v-card) {
  box-shadow: inset 0 26px 20px -30px #0404042e !important;
}

.v-overlay {
  top: 90px !important;
  z-index: 200 !important;
}
</style>